import {connect} from 'react-redux';
import {AnyAction} from 'redux';
import {ThunkDispatch} from 'redux-thunk';

import NavigationProp from '../../../../../navigators/NavigationProp';

import New, {
  DispatchProps,
  StateProps,
} from '../../../../../components/scene_form/background_show_scene_command/new/backgrounds/New';

import AppState from '../../../../../reducers/AppState';

import indexBackgroundTimeZones, {
  Params as BackgroundTimeZoneIndexParams,
} from '../../../../../actions/background_time_zones/index';
import updateBackgroundUsageHistory, {
  Params as BackgroundUsageHistoryUpdateParams,
} from '../../../../../actions/background_usage_histories/update';
import indexBackgroundWeathers, {
  Params as BackgroundWeatherIndexParams,
} from '../../../../../actions/background_weathers/index';
import indexBackgrounds, {
  Params as BackgroundIndexParams,
} from '../../../../../actions/backgrounds/index';
import showBaseBackground from '../../../../../actions/base_backgrounds/show';
import updateSceneForm, {
  Params as SceneFormUpdateParams,
} from '../../../../../actions/scene_forms/update';
import updateCoachmarkModal, {
  Params as CoachmarkModalUpdateParams,
} from '../../../../../actions/coachmark_modal/update';
import {NewSceneFormBackgroundShowSceneCommandNewBackgroundRouteProp} from '../../../../../navigators/RouteProps';

interface Props {
  navigation: NavigationProp;
  route: NewSceneFormBackgroundShowSceneCommandNewBackgroundRouteProp;
}

const mapStateToProps = (state: AppState, props: Props): any => {
  const {navigation} = props;
  const {forms, modals} = state;
  const sceneForm = forms.sceneForm;
  const {coachmarkModal} = modals;
  return {
    navigation,
    sceneForm,
    coachmarkModal,
  };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch<AppState, void, AnyAction>,
) => {
  return {
    updateBackgroundUsageHistory: (
      id: number,
      params: BackgroundUsageHistoryUpdateParams,
    ) => dispatch(updateBackgroundUsageHistory(id, params)),
    updateSceneForm: (params: SceneFormUpdateParams) =>
      dispatch(updateSceneForm(params)),
    updateCoachmarkModal: (params: CoachmarkModalUpdateParams) =>
      dispatch(updateCoachmarkModal(params)),
  };
};

export default connect<StateProps, DispatchProps, Props, AppState>(
  mapStateToProps,
  mapDispatchToProps,
)(New);
